import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CategorySection } from './components/CategorySection';
import { FeaturedProducts } from './components/FeaturedProducts';
import { WorkshopSection } from './components/WorkshopSection';
import { CustomWork } from './components/CustomWork';
import { StorySection } from './components/StorySection';
import { FaqSection } from './components/FaqSection';
import { ClosingCta } from './components/ClosingCta';
import { Footer } from './components/Footer';
const TITLE = 'Metal Shaping Tools & Workshops | Fournier Enterprises';
const DESCRIPTION = 'Shop metal shaping tools, English wheels and fabrication equipment. Explore hands-on workshops and custom metalwork in Mt. Clemens, Michigan.';
export function App() {
  useEffect(() => {
    document.title = TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', DESCRIPTION);
  }, []);
  return <div className="w-full bg-cream" data-id="element-0" data-mp="3mjpyb4i388ps">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-charcoal focus:px-4 focus:py-2 focus:text-white" data-id="element-1" data-mp="3rcj31sdk3h1v">
        Skip to content
      </a>
      <Header data-id="element-2" data-mp="2zm4wyibsb90r" />
      <main id="main" data-id="element-3" data-mp="2zmo3z3zwcd00">
        <Hero data-id="element-4" data-mp="2zn6cp03qwjot" />
        <CategorySection data-id="element-5" data-mp="33mow1rfx4mpj" />
        <FeaturedProducts data-id="element-6" data-mp="33lwyib2rgewm" />
        <WorkshopSection data-id="element-7" data-mp="33n6zb810016y" />
        <CustomWork data-id="element-8" data-mp="33orkw85c49so" />
        <StorySection data-id="element-9" data-mp="38m1gy6n8bjph" />
        <FaqSection data-id="element-10" data-mp="38li6tc3tlzm0" />
        <ClosingCta data-id="element-11" data-mp="38k6tolohjfi8" />
      </main>
      <Footer data-id="element-12" data-mp="38o4edbqpof48" />
    </div>;
}